/**
 * ヒーロー画像スライドショー
 * - 5秒間隔で自動ローテーション
 * - 前後ボタン・ドットナビで手動切替
 * - hover / focus / タブ非表示時は一時停止
 * - スワイプ対応 (モバイル)
 * - キーボード (←/→) 対応
 */

(function () {
  'use strict';

  const INTERVAL_MS = 5000;
  const SWIPE_THRESHOLD = 50;

  document.querySelectorAll('[data-hero-slides]').forEach((container) => {
    const slides = Array.from(container.querySelectorAll('.hero-slides__slide'));
    const dots = Array.from(container.querySelectorAll('[data-hero-dot]'));
    const prevBtn = container.querySelector('[data-hero-prev]');
    const nextBtn = container.querySelector('[data-hero-next]');

    if (slides.length < 2) return;

    let current = 0;
    let timer = null;
    let isPaused = false;

    // D-1: プログレスバー注入
    const progressTrack = document.createElement('div');
    progressTrack.className = 'hero-slides__progress';
    const progressBar = document.createElement('div');
    progressBar.className = 'hero-slides__progress-bar';
    progressTrack.appendChild(progressBar);
    container.insertBefore(progressTrack, container.firstChild);

    function restartProgress() {
      progressBar.classList.remove('is-running');
      // 強制リフロー (アニメーションリセット)
      void progressBar.offsetWidth;
      if (!isPaused) {
        progressBar.classList.add('is-running');
      }
    }

    function activate(index) {
      const next = ((index % slides.length) + slides.length) % slides.length;
      if (next === current) return;
      slides[current]?.classList.remove('is-active');
      dots[current]?.classList.remove('is-active');
      current = next;
      slides[current]?.classList.add('is-active');
      dots[current]?.classList.add('is-active');
      restartProgress();
    }

    function start() {
      stop();
      if (isPaused) return;
      timer = setInterval(() => activate(current + 1), INTERVAL_MS);
      restartProgress();
    }

    function stop() {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    }

    function pause() {
      isPaused = true;
      stop();
      progressBar.classList.add('is-paused');
    }

    function resume() {
      isPaused = false;
      progressBar.classList.remove('is-paused');
      start();
    }

    // ---------- 前後ボタン ----------
    prevBtn?.addEventListener('click', (e) => {
      e.preventDefault();
      activate(current - 1);
      start();
    });

    nextBtn?.addEventListener('click', (e) => {
      e.preventDefault();
      activate(current + 1);
      start();
    });

    // ---------- ドットナビ ----------
    dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        const idx = parseInt(dot.dataset.heroDot, 10);
        if (!Number.isNaN(idx)) {
          activate(idx);
          start();
        }
      });
    });

    // ---------- hover / focus で一時停止 ----------
    container.addEventListener('mouseenter', pause);
    container.addEventListener('mouseleave', resume);
    container.addEventListener('focusin', pause);
    container.addEventListener('focusout', resume);

    // ---------- タッチスワイプ ----------
    let touchStartX = 0;
    container.addEventListener(
      'touchstart',
      (e) => {
        touchStartX = e.touches[0].clientX;
        pause();
      },
      { passive: true }
    );
    container.addEventListener(
      'touchend',
      (e) => {
        const diff = touchStartX - e.changedTouches[0].clientX;
        if (Math.abs(diff) > SWIPE_THRESHOLD) {
          activate(current + (diff > 0 ? 1 : -1));
        }
        resume();
      },
      { passive: true }
    );

    // ---------- キーボード ----------
    container.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft') {
        e.preventDefault();
        activate(current - 1);
        start();
      } else if (e.key === 'ArrowRight') {
        e.preventDefault();
        activate(current + 1);
        start();
      }
    });

    // ---------- タブ非表示時に停止 ----------
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) {
        pause();
      } else {
        resume();
      }
    });

    // 初期起動
    start();
  });
})();
